const basePath = process.env.BASE_PATH;

export function prefixBasePath(path) {
  path = path.startsWith('/') ? path : `/${path}`;
  if (basePath === '/') {
    return path;
  } else {
    return `${basePath}${path}`;
  }
}
